import { useLocalStorage } from '@buffer-mono/popcorn'

import {
  newCalendarSingleChannel,
  channel as channelRoute,
} from '~publish/legacy/routes'

import useMatchCurrentOrParentPath from './useMatchCurrentOrParentPath'

const STORE_KEY = 'showTimeSlots'

export function useSlotsEnabled(): [boolean, (enabled: boolean) => void] {
  const singleChannelCalendarMatch = useMatchCurrentOrParentPath(
    newCalendarSingleChannel.route,
  )
  const singleChannelMatch = useMatchCurrentOrParentPath(channelRoute.route)
  const isSingleChannel = !!singleChannelCalendarMatch || !!singleChannelMatch

  const [showTimeSlots, setShowTimeSlots] = useLocalStorage(
    STORE_KEY,
    isSingleChannel,
  )

  if (!isSingleChannel) {
    return [
      false,
      (): void => {
        /** do nothing */
      },
    ]
  }

  return [showTimeSlots, setShowTimeSlots]
}
